import i18n from 'i18next';
import {HStack, Text} from 'platform/foundation';

import {type BulkOperationResponseBody} from '../../types/api/bulkOperations';

type BulkOperationCountsProps = {
  operation: BulkOperationResponseBody;
};

export function BulkOperationCounts(props: BulkOperationCountsProps) {
  return (
    <HStack spacing={4} wrap>
      <Text size="small">
        {i18n.t('general.labels.total')}: {props.operation.totalCount}
      </Text>
      <Text size="small">
        {i18n.t('general.notifications.success')}: {props.operation.doneCount}
      </Text>
      <Text size="small">
        {i18n.t('general.notifications.labels.failed')}: {props.operation.failedCount}
      </Text>
      <Text size="small">
        {i18n.t('entity.automationRule.detail.runResult.skipped')}: {props.operation.skippedCount}
      </Text>
    </HStack>
  );
}
